import designItem from './DesignCheckBox.vue'
const DesignCheckBox = {
  install: function (Vue) {
    Vue.component('DesignCheckBox', designItem)
  }
}
export default DesignCheckBox
